import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { RootState, HotelState, Hotel } from '@/definitions'
import { AxiosResponse } from 'axios'
import axios from '@/plugins/axios'
import Swal from 'sweetalert2'
import dayjs from 'dayjs'

const state: HotelState = {
  hotels: []
}

const getters: GetterTree<HotelState, unknown> = {
  hotels: (state): Hotel[] => state.hotels
}

const mutations: MutationTree<HotelState> = {
  setHotel (state, hotels: Hotel[]): void {
    state.hotels = hotels
  }
}

const actions: ActionTree<HotelState, RootState> = {
  async fetchHotels ({ commit }): Promise<void> {
    try {
      const res: AxiosResponse = await axios.get('/portal/hotels')
      const hotels: Hotel[] = res.data.data.map((item: any) => {
        return {
          id: item.id,
          name: item.name,
          description: item.description,
          coverImage: item.cover_image,
          isActive: item.is_active === 1,
          isFeatured: item.is_featured === 1,
          createdAt: dayjs(item.created_at)
        }
      })
      commit('setHotel', hotels)
    } catch (error) {
      if (error.response) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.message
        })
      } else if (error.request) {
        console.log(error.request)
      } else {
        console.log('Error', error.message)
      }
    }
  }
}

export const hotel: Module<HotelState, RootState> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
